.container {
  background-color: white;
  break-after: page;
  break-inside: avoid-page;
}

.notes {
  border-top: 1px solid black;
}
